module.exports = __webpack_public_path__ + "img/Logo Loading Full Loop 150x150.e33fd7cf.gif";